/**
 * Parses a PGA_DISCLAIM `requestId` of the form `batchId#identifier#flag`. The
 * batch id may contain `#`, so we anchor on the last two segments.
 */
export interface ParsedComplianceCheckRequestId {
  batchId?: string;
  identifier?: string;
  flag?: string;
}

export const parseComplianceCheckRequestId = (
  requestId?: string | null,
): ParsedComplianceCheckRequestId => {
  if (!requestId) return {};
  const parts = requestId.split('#');
  if (parts.length < 3) return {};
  const flag = parts[parts.length - 1];
  const identifier = parts[parts.length - 2];
  const batchId = parts.slice(0, parts.length - 2).join('#');
  // A trailing/leading empty segment means the id is malformed for our purposes.
  if (!flag || !identifier || !batchId) return {};
  return { batchId, identifier, flag };
};
